import styled from 'styled-components'

export default styled.div`
  position: absolute;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`
